import React, { useCallback } from 'react';
import { useExperiment } from '../../experiments/useExperiment';
import { trackExperiment } from '../../experiments/track';
import HomeControl from './variants/HomeControl';
import HomeTreatment from './variants/HomeTreatment';

const EXPERIMENT_NAME = 'home_hero_redesign';

export default function HomeIndexLayout({ links = [] }) {
  const variant = useExperiment(EXPERIMENT_NAME);

  const onCtaClick = useCallback((label) => {
    trackExperiment(EXPERIMENT_NAME, variant, 'experiment_click', { cta_label: label });
  }, [variant]);

  const Variant = variant === 'treatment' ? HomeTreatment : HomeControl;
  return <Variant links={links} onCtaClick={onCtaClick} />;
}
